<template>
    <div>
        <div class>
            <div class="py-4 pt-4">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="username">Zgjedh perdoruesin:</label>
                <div v-if="isAdmin" class="inline-block relative">
                    <select  @change="getAllComments" class="appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    v-model="user">
                        <option></option>
                        <option
                        v-for="(user, id) in users" :value="{ id:user.id, text: user.name}" :key="id"
                        >{{ user.name }}</option>
                    </select>
                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                        class="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                    </div>
                </div>
                <div v-else  class="inline-block relative">
                    <select  @change="getAllComments" class="appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    v-model="user">
                        <option></option>
                        <option
                        v-for="(user, id) in users" :value="{ id:user.id, text: user.name}" :key="id"
                        >{{ user.name }}</option>
                    </select>
                       <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg
                            class="fill-current h-4 w-4"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            >
                            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                            </svg>
                    </div>
                </div>
                <div class="float-right right-50">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="username">Zgjedhe Daten:</label>
                <form @change="getDate" class="float-left mr-2">
                    <div class="w-40">
                    <vc-date-picker
                        v-model="dateFirst"
                        :first-day-of-week="2"
                        :masks="{ title: 'MMMM YYYY', L: 'DD-MM-YYYY' }"
                    ></vc-date-picker>
                    </div>
                </form>
                <form @change="getDate" class="float-right">
                    <div class="w-40">
                    <vc-date-picker
                        v-model="dateSecond"
                        :first-day-of-week="2"
                        :masks="{ title: 'MMMM YYYY', L: 'DD-MM-YYYY' }"
                    ></vc-date-picker>
                    </div>
                </form>
            </div>
            </div>
            <div class="mb-4 py-4 mx-2" v-if="isAdmin">
                
                <div class="w-1/2">
                    <div class="flex">
                        <div>
                            <label for="titulli" class="block text-gray-700 text-sm font-bold mb-2">TITULLI</label>
                        <input v-model="title" class="shadow appearance-none border rounded w-auto py-2 px-3 
                        text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-2">
                        </div>
                    </div>
                    <div class="flex">
                        <div class="w-1/2">
                            <label class="block text-gray-700 text-sm font-bold mb-2" for="kategori">KATEGORIA:</label>
                            <div v-if="isAdmin" class="inline-block relative">
                                <select v-model="category" class="appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                                >
                                    <option value=""></option>
                                    <option value="Mungese performance">Mungese performance</option>
                                    <option value="MINUS">MINUS</option>
                                    <!-- <option
                                    v-for="(user, id) in users" :value="{ id:user.id, text: user.name}" :key="id"
                                    >{{ user.name }}</option> -->
                                    <option value="TJERA">TJERA</option>
                                </select>
                                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                <svg
                                    class="fill-current h-4 w-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    >
                                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex">
                        <div>
                            <label for="vlera" class="block text-gray-700 text-sm font-bold mb-2">VLERA</label>
                            <input v-model="value" class="shadow appearance-none border rounded w-auto py-2 px-3 
                            text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-2">
                        </div>
                    </div>

                    <!-- <div class="flex">
                        <div>
                            <label for="username" class="block text-gray-700 text-sm font-bold mb-2">KOMENTI</label>
                            <textarea v-model="comment" class="shadow appearance-none border rounded w-auto py-2 px-3 
                                text-gray-700 leading-tight focus:outline-none focus:shadow-outline" cols="20" rows="4">
                            </textarea>
                        </div>
                        <div class="ml-3 mt-10" >
                            <button type="submit" @click="addComment" class="block text-center uppercase focus:outline-none shadow bg-teal-400 
                            hover:bg-teal-300 text-white text-xs py-2 px-5 rounded mb-2">
                                SHTO KOMENT
                            </button>
                        </div>
                    </div> -->
                    
                </div>
                <div class="flex w-1/2">
                    <div>
                        <label for="username" class="block text-gray-700 text-sm font-bold mb-2">KOMENTI</label>
                        <textarea v-model="comment" class="shadow appearance-none border rounded w-auto py-2 px-3 
                        text-gray-700 leading-tight focus:outline-none focus:shadow-outline" cols="20" rows="4">
                    </textarea>
                    </div>
                    <div class="ml-3 mt-10" >
                        <button type="submit" @click="addComment" class="block text-center uppercase focus:outline-none shadow bg-teal-400 
                        hover:bg-teal-300 text-white text-xs py-2 px-5 rounded mb-2">
                            SHTO KOMENT
                        </button>
                        <!-- <button
                            @click="getComments()"
                            class="block uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded">
                            See Comments
                        </button> -->
                    </div>
                </div>
                </div>
                <p class="text-green-600">{{ this.success }}</p>
                <!-- <p class="text-red-600">{{ this.errorComment }}</p> -->
            
            <div class="flex">
                <button
                    @click="filterTasks()"
                    class="block mr-2 uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded">
                    Filter
                </button>
                <button @click="print()"
                        class="block mr-2 uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded">
                    Export Pdf
                </button>
                <vue-excel-xlsx v-if="user"
                    class="block mr-2 uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
                    :data="finishedTasks"
                    :columns="columns"
                    :filename="'FinishedTasks_'+this.user.text+'_'+formatDate(this.dateFirst)+'_'+formatDate(this.dateSecond)"
                    :sheetname="'FinishedTasks'"
                >
                    Export Excel
                </vue-excel-xlsx>
                <vue-excel-xlsx v-if="user"
                    class="block mr-2 uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
                    :data="commentsForUser"
                    :columns="commentsColumns"
                    :filename="'Comments_'+this.user.text"
                    :sheetname="'Comments'"
                >
                    Export Excel Comments
                </vue-excel-xlsx>
                <button
                    @click="back()"
                    class="block uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded">
                    Back
                </button>
            </div>
        </div>
        
        <div class="flex flex-col py-4 font-semibold" id=print> 

            <h1 v-if="user" class="text-center text-xl">{{ user.text }}</h1>
    
            <div class v-if="!error">
                <div class="align-middle inline-block min-w-full overflow-hidden border border-gray-400 mt-3">
                    <table class="min-w-full">
                        <thead>
                            <tr>
                                <th
                                class="px-2 py-2 w-4 border border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
                                >NR</th>
                                <th
                                class="px-2 py-2 border w-2/6 border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
                                >TITLE</th>
                                <th
                                class="px-2 py-2 border w-1/6 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                                >COMMENT</th>
                                <th
                                class="px-2 py-2 border w-4 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                                >PRIORITY</th>
                                <th
                                class="px-2 py-2 w-30 border border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                                >DL</th>
                                <th
                                class="px-2 py-2 w-6 border border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                                >FINISHED</th>
                                <th
                                class="px-2 py-2 border border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                                >CREATOR</th>
                            </tr>
                        </thead>
                        <tbody class="bg-white">
                            <tr v-for="(finishedTask, index) in finishedTasks"
                                :key="index.id"
                                :class=" 'bg-green-200'">
                                <td
                                class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                                >{{ ++index }}</td>
                                <td
                                class="px-2 py-2 w-2/6 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                                >{{ finishedTask.title }}</td>
                                <td
                                class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                                >{{ finishedTask.comment }}</td>
                                <td
                                class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                                >{{ finishedTask.priority }}</td>
                                <td class="px-2 py-2 w-30 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                                >{{ formatDate(finishedTask.day) }}
                                </td>
                                <td
                                class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                                >
                                    <div class="text-center">
                                        YES
                                    </div>
                                </td>
                                <td
                                class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                                >{{ finishedTask.user }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- TABELA E KOMENTEVE -->
             <div class v-if="loggedInUser == user_id || isAdmin == true" >
                <div class="align-middle inline-block min-w-full overflow-hidden border border-gray-400 mt-3">
                    <table class="min-w-full">
                        <thead>
                            <tr>
                                <th
                                class="px-2 py-2 w-4 border border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
                                >Nr</th>
                                <th
                                class="px-2 py-2 border w-4 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                                >TITULLI</th>
                                <th
                                class="px-2 py-2 border w-4 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                                >KATEGORIA</th>
                                <th
                                class="px-2 py-2 border w-4 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                                >VLERA</th>
                                <th
                                class="px-2 py-2 border w-4 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                                >KOMENTI</th>
                                <th  v-if="isAdmin" class="px-2 py-2 border w-4 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider">Ndrysho/Fshije</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr  v-for="(commentForUser, index2) in commentsForUser"
                                :key="index2.id">
                                <td
                                class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                                >{{ ++index2 }}</td>
                                <td
                                class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                                >{{ commentForUser.title }}</td>
                                <td
                                class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                                >{{ commentForUser.category }}</td>  
                                <td
                                class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                                >{{ commentForUser.value }}</td>
                                <td
                                class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                                >{{ commentForUser.comment }}</td>
                                <td v-if="isAdmin"  class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900">
                                    <router-link
                                        :to="{
                                        name: 'edit-comment',
                                        params: { id: commentForUser.id, user_id: commentForUser.user_id},
                                        }"
                                    >
                                        <span
                                        class="text-indigo-600 hover:text-indigo-900 focus:outline-none focus:underline"
                                        >NDRYSHO/</span>
                                    </router-link>

                                    <span class="ml-2">
                                        <button @click="deleteComment(commentForUser.id)"
                                        
                                        class="text-indigo-600 font-semibold hover:text-indigo-900 focus:outline-none focus:underline"
                                        >FSHIJE</button>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import moment from "moment";
  
    export default {
        components: {
            
        },
        props: {
            date: String,
        },
        data() {
            return {
            dateFirst: '',
            dateSecond: '',
            finishedTasks: [],
            error: false,
            users: [],
            commentsForUser:[],
            url: "",
            user: null,
            columns: [

                    { label: "TITLE", field: "title" },
                    { label: "COMMENT", field: "comment" },
                    { label: "PRIORITY", field: "priority" },
                    { label: "DAY", field: "day" },
                    { label: "CREATOR", field: "user" },
                    { label: "DEVELOPER", field: "developer" }
                ],
            commentsColumns: [
                { label: "TITULLI", field: "title" },
                { label: "KATEGORIA", field: "category" },
                { label: "VLERA", field: "value" },
                { label: "KOMENTI", field: "comment" },
            ],
            user_id: '',
            name: "",
            comment: "",
            category:"",
            title:"",
            value:"",
            success:"",
            errorComment:"",
            isAdmin: false,
            loggedInUser: null,
            comment_id: null,
            };

        },
        created() {
            this.getTasksByUser();
            this.getUser();
          
        },
        methods: { 
            getUser() {
                axios.defaults.headers.common["Authorization"] =
                    "Bearer " + localStorage.getItem("access_token");

                 axios
                    .get(`${process.env.VUE_APP_API}/user`)
                    .then((response) => {
                        
                        if(response.data.data.is_admin == 1)
                        {
                            this.isAdmin = true;
                            
                        }
                        else {
                            this.loggedInUser = response.data.data.id;
                            this.getComments();
                        }
                        console.log(this.loggedInUser);
                    // console.log(response);
                    })
                    .catch((error) => console.log(error));

            },
            formatDate(date) {
                return moment(date).format("YYYY-MM-DD"); 
            },
            getFinishedTasks() {
                axios.defaults.headers.common["Authorization"] =
                    "Bearer " + localStorage.getItem("access_token");

                axios
                    .get(`${process.env.VUE_APP_API}/detyrat-e-kryera`)
                    .then((response) => {
                    this.finishedTasks = response.data.data;
                    })
                    .catch((error) => console.log(error));
            },

            getTasksByUser() {
                axios.defaults.headers.common["Authorization"] =
                    "Bearer " + localStorage.getItem("access_token");

                 axios.get(`${process.env.VUE_APP_API}/excel/users`)
                    .then((response) => {
                        this.users = response.data;
                    })
                    .catch((error) => console.log(error));
            },

            filterTasks() {
                axios.defaults.headers.common["Authorization"] =
                    "Bearer " + localStorage.getItem("access_token");
                
                console.log(this.dateSecond);
                
                this.url = `${process.env.VUE_APP_API}/detyrat-e-kryera/${this.user.id}/${this.formatDate(this.dateFirst)}/${this.formatDate(this.dateSecond)}`; 

                axios.get(`${this.url}`).then((response) => {
                    console.log(this.url);
                    console.log(response);
                    this.finishedTasks = response.data.data;
                });

            },
            addComment() {
                axios.defaults.headers.common["Authorization"] =
                    "Bearer " + localStorage.getItem("access_token");
                
                axios.post(`${process.env.VUE_APP_API}/comment-for-user`, {
                    user_id: this.user.id,
                    name: this.user.text,
                    comment: this.comment,
                    title: this.title,
                    category: this.category,
                    value: this.value
                })
                .then((response) => {
                    this.getAllComments();
                    console.log(response.data.error);
                    this.success = response.data.success;
                    this.errorComment = response.data.error;
                    this.comment = "";
                })
                .catch((error) => console.log(error));
            },
            getComments() {
                 axios
                    .get(`${process.env.VUE_APP_API}/comment-for-user/${this.loggedInUser}`)
                    .then((response) => {
                    this.commentsForUser = response.data;
                    this.user_id = this.loggedInUser;
                    
                    })
                    .catch((error) => console.log(error));
            },
            getAllComments() {
                 axios
                    .get(`${process.env.VUE_APP_API}/comment-for-user/${this.user.id}`)
                    .then((response) => {
                        this.commentsForUser = response.data;
                        this.user_id = response.data[0].user_id;
                        console.log(response.data);
                    })
                    .catch((error) => console.log(error));
            },
            deleteComment(id) {
                axios.defaults.headers.common["Authorization"] =
                    "Bearer " + localStorage.getItem("access_token");

                if (confirm("A jeni i sigurt qe deshironi ta fshini detyren?")) {
                    axios
                    .delete(`${process.env.VUE_APP_API}/comment-for-user/${id}`)
                    .then(() => {
                        const index = this.commentsForUser.findIndex(
                         (commentForUser) => commentForUser.id === id
                        ); // find the task index
                        if (~index)
                        // if the task exists in array
                        this.commentsForUser.splice(index, 1); //delete the task
                        console.log("okk");
                    })
                    .catch((error) => console.log(error));
                }
            },

            // updateComment(id) {
            //     axios.defaults.headers.common["Authorization"] =
            //         "Bearer " + localStorage.getItem("access_token");

            //     axios.put(`${process.env.VUE_APP_API}/comment-for-user/${id}`, {
            //             user_id: this.user_id,
            //             name: this.user.text,
            //             comment: this.commentsForUser.comment,
            //         })
            //         .then(() => {
            //             console.log(this.commentsForUser.comment);
            //        // this.$router.push("/finished-tasks");
            //         })
            //         .catch(function(error) {
            //         console.log(error);
            //         });
            // },
            print() { 
                this.$htmlToPaper("print");
            },
            back() {
                this.$router.push('/fast-tasks');
            },
             getDate() {},
        }
    }
</script>
